export type UnsubscribeFunc = () => void
export type UnsubscribeHandle = { unsubscribe(): void }
export type Subscription = UnsubscribeFunc | UnsubscribeHandle

export type Mutable<T> = {
  -readonly [K in keyof T]: T[K] extends ReadonlyArray<infer U>
    ? Array<U>
    : Mutable<T[K]>;
}

/**
 * This function is a hack to get the relay-generated types to play nicely.
 * Our types are so inconsistent (both in shape and usage) that getting everything to work nicely will take time.
 */
export function mutable<T>(immutable: unknown) {
  return immutable as Mutable<T>
}
